import React, { useEffect, useState } from 'react';
import VideoHlroomAnalytics from '@sky-it-video/hlroom-analytics';

import TypographyElements from '../../foundation/typography/typography-element/typography-elements';
import styles from '../../../utils/styles';
import { ISubSection, ISubSubSection } from '../../../typings/hlroom';
import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';

import './SubSectionsMenu.scss';

export interface ISubSectionsMenu {
  isDesktop: boolean;
  subSectionSelected: ISubSection;
  subSubSectionSelected: ISubSubSection | undefined;
  onSubSubSectionChange: (subSubSection: ISubSubSection | undefined) => void;
  isOpen?: boolean;
  onSetIsOpen?: () => void;
  appType?: string;
}

const SubSectionsMenu: React.FC<ISubSectionsMenu> = ({
  isDesktop,
  subSectionSelected,
  subSubSectionSelected,
  onSubSubSectionChange,
  isOpen = false,
  onSetIsOpen,
  appType = 'sport',
}) => {
  const pivot = Math.ceil(subSectionSelected.subSubSections.length / 2);
  const [leftSection, setLeftSection] = useState(Array<ISubSubSection>);
  const [rightSection, setRightSection] = useState(Array<ISubSubSection>);

  useEffect(() => {
    setLeftSection(subSectionSelected.subSubSections.slice(0, pivot));
    setRightSection(subSectionSelected.subSubSections.slice(pivot, subSectionSelected.subSubSections.length));
  }, [pivot, subSectionSelected]);

  const handleChangeSubSubSectionSelected = (subSubSection?: ISubSubSection) => {
    VideoHlroomAnalytics.setDigitalData(
      {
        zoneid: {
          subSection: subSectionSelected.tag?.replace(' ', '-'),
          subSubSection: subSubSection?.tag?.replace(' ', '-'),
        },
      },
      appType
    );
    onSubSubSectionChange(subSubSection);
    window.scrollTo(0, 0);
    !isDesktop && onSetIsOpen && onSetIsOpen();
  };

  return (
    <div className={styles('subsection-menu', isOpen && 'subsection-menu--open')}>
      {isDesktop && subSectionSelected.subSubSections.length > 0 && (
        <React.Fragment>
          <div className={styles('subsection-menu__header')}>
            <TypograpyHeadingComponent text="Altre competizioni" headingTag="h3" />
          </div>

          <div className={styles('subsection-menu__container')}>
            {subSectionSelected.subSubSections.map((subSubSection, index) => {
              return (
                !subSubSection.top && (
                  <button
                    key={`${subSubSection.name}-${index}`}
                    onClick={() => handleChangeSubSubSectionSelected(subSubSection)}
                    type="button"
                    aria-label={subSubSection.name}
                    className={styles('subsection-menu__container--button')}
                  >
                    <TypographyElements
                      text={subSubSection.name}
                      typographyClass={styles(
                        'ty-elements-medium--uppercase',
                        'menu__container__text',
                        subSubSectionSelected &&
                          subSubSectionSelected.tag === subSubSection.tag &&
                          'menu__container__text--active'
                      )}
                    />
                  </button>
                )
              );
            })}
          </div>
        </React.Fragment>
      )}

      {!isDesktop && isOpen && (
        <React.Fragment>
          <div className={styles('subsection-menu__image')}>
            <img src={subSectionSelected.images.menu?.mobile} alt={subSectionSelected.images.menu?.alt} />
          </div>

          <div className={styles('subsection-menu__container')}>
            <div className={styles('container__left')}>
              <button
                type="button"
                aria-label={subSectionSelected.name}
                className={styles('subsection-menu__container--button')}
                onClick={() => handleChangeSubSubSectionSelected()}
              >
                <TypographyElements
                  text={`Tutto ${subSectionSelected.name}`}
                  typographyClass={styles(
                    'ty-elements-medium--uppercase',
                    'menu__container__text',
                    Boolean(!subSubSectionSelected) && 'menu__container__text--active'
                  )}
                />
              </button>

              {leftSection.map((leftSubSubSection, index) => (
                <div
                  key={`${leftSubSubSection.name}-${index}`}
                  onClick={() => handleChangeSubSubSectionSelected(leftSubSubSection)}
                >
                  <TypographyElements
                    text={leftSubSubSection.name}
                    typographyClass={styles(
                      'ty-elements-medium--uppercase',
                      'menu__container__text',
                      Boolean(subSubSectionSelected) &&
                        subSubSectionSelected?.tag === leftSubSubSection.tag &&
                        'menu__container__text--active'
                    )}
                  />
                </div>
              ))}
            </div>

            <div className={styles('container__right')}>
              {rightSection.map((rightSubSubSection, index) => {
                return (
                  <div
                    key={`${rightSubSubSection.name}-${pivot + index}`}
                    onClick={() => handleChangeSubSubSectionSelected(rightSubSubSection)}
                  >
                    <TypographyElements
                      text={rightSubSubSection.name}
                      typographyClass={styles(
                        'ty-elements-medium--uppercase',
                        'menu__container__text',
                        Boolean(subSubSectionSelected) &&
                          subSubSectionSelected?.tag === rightSubSubSection.tag &&
                          'menu__container__text--active'
                      )}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default SubSectionsMenu;
